import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const priceStr =
          product.variantPrices?.[item.size] || product.price;
        const price = parseFloat(priceStr.toString().replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__empty">
          <h2>Your cart is empty</h2>
          <Link onClick={toTop} to="/shop">
            Continue Shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-page__header-title">
        <h1>Your cart</h1>
        <Link to="/shop" className="continue-shopping">Continue shopping</Link>
      </div>
      
      <div className="cart-page__container">
        <div className="cart-page__items">
          <div className="cart-page__header">
            <div className="cart-page__header-product">PRODUCT</div>
            <div className="cart-page__header-price">PRICE</div>
            <div className="cart-page__header-quantity">QUANTITY</div>
            <div className="cart-page__header-total">TOTAL</div>
          </div>
          
          {cartItems.map((item, index) => {
            const product = getProductById(item.id);
            if (!product) return null;

            const priceStr = product.variantPrices?.[item.size] || product.price;
            const price = parseFloat(priceStr.toString().replace(/,/g, ""));
            const itemTotal = price * item.quantity;

            return (
              <div key={`${item.id}-${item.size}-${item.color}-${index}`} className="cart-item">
                <div className="cart-item__product">
                  <div className="cart-item__image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="cart-item__details">
                    <h3>{product.name}</h3>
                    {item.size && <p>Edition: {item.size}</p>}
                    {item.color && <p>Color: {item.color}</p>}
                    <button 
                      className="cart-item__remove"
                      onClick={() => removeFromCart(item.id, item.size, item.color)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
                
                <div className="cart-item__price">
                  ${price.toFixed(2)}
                </div>

                <div className="cart-item__quantity">
                  <input 
                    type="number" 
                    min="1" 
                    value={item.quantity} 
                    onChange={(e) => handleUpdateQuantity(item.id, item.size, item.color, parseInt(e.target.value) || 1)}
                  />
                </div>
                
                <div className="cart-item__total">
                  ${itemTotal.toFixed(2)}
                </div>
              </div>
            );
          })}
        </div>

        <div className="cart-page__footer">
          <div className="cart-page__summary-wrapper">
            <div className="cart-page__subtotal">
              <span>Subtotal</span>
              <span className="amount">${subtotal.toFixed(2)} USD</span>
            </div>
            <p className="cart-page__taxes">Tax included. Shipping calculated at checkout.</p>
          </div>

          <div className="cart-page__notice">
            <strong>Customer Notice:</strong> Orders are normally prepared within 1–3 business days. Standard tracked shipping is $9.99 per order.
          </div>

          <div className="cart-page__checkout-wrapper">
            <button className="cart-page__checkout-btn" onClick={handleCheckout}>
              CHECK OUT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
